import { Component, OnInit, Input } from '@angular/core';
import { CompanyService } from '../../../onboarding/services/company.service';
import { Company } from '../../../onboarding/classes/company';
import { Router } from '@angular/router';
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'app-admin-top-bar',
  templateUrl: './admin-top-bar.component.html',
  styleUrls: ['./admin-top-bar.component.scss']
})
export class AdminTopBarComponent implements OnInit {
  @Input() name: string;
  @Input() transparent: boolean;
  @Input() backgroundColor: string;
  @Input() color: string;
  @Input() orgId: number;
  company: Company;

  constructor(private CompanyService: CompanyService, private Router: Router, private UserService: UserService) { }

  ngOnInit() {
    let u: string = JSON.parse(localStorage.onboardingUser).user;
    this.name = JSON.parse(u).first_name;
    this.orgId && this.CompanyService.getCompany(this.orgId)
      .subscribe(org => {
        this.company = JSON.parse(org.organization);
      })

    let admin: boolean = JSON.parse(u).admin;
    if (!admin) {
      this.Router.navigate(['admin/unauthorized']);
    }
  }

  logOut() {
    this.UserService
      .logOut()
      .subscribe(
      res => { this.Router.navigate(['/']) },
      err => { }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/components/admin-top-bar/admin-top-bar.component.ts